import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SerieOverviewItem } from '@core/models/serie-overview-item';
import { TrackingService } from '@core/services/tracking.service';
import { extractNamesArray } from '@core/utils/helpers';

@Component({
	selector: 'kwo-serie-item',
	standalone: true,
	templateUrl: './serie-item.component.html',
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SerieItemComponent {

	private trackingService = inject(TrackingService);

	@Input() serie!: SerieOverviewItem;

	@Output() serieClick = new EventEmitter<string>();

	goToSerie() {
		this.trackingService.track('Serie Cover Click', {
			video_id: this.serie.id,
			serie_name: this.serie.name,
			serie_cover_image_url: this.serie.cover,
		});

		this.serieClick.emit(this.serie.slug);
	}
} 